import React, { memo, useEffect, useState } from 'react'

import FilterSearchInput from 'Pods/SearchPage/Components/Shared/FilterSearchInput/FilterSearchInput'
import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import { useSearchPageStore } from 'Pods/SearchPage/Store'
import { cancelKeywordCommit, commitKeyword } from 'Pods/SearchPage/Store/actions/keyword'

function SearchWithinResults() {
  const translate = useTranslate()

  const keyword = useSearchPageStore(state => state.keyword)
  // Clears usually write the same '' the store already holds, so `keyword` alone would not rerender
  // this component and the input would keep showing a term that is no longer applied. The counter
  // changes on every clear (Store/slices/keyword.js), which is what makes the resync fire.
  const keywordClearCount = useSearchPageStore(state => state.keywordClearCount)
  const [value, setValue] = useState(keyword)

  // External store writes (Reset button, switching back to "All assets", popstate restore) must
  // win: sync the input and drop any pending commit so stale text cannot resurrect the value the
  // external write just cleared.
  useEffect(() => {
    cancelKeywordCommit()
    setValue(keyword)
  }, [keyword, keywordClearCount])

  useEffect(() => cancelKeywordCommit, [])

  const handleChange = (nextValue) => {
    setValue(nextValue)
    commitKeyword(nextValue)
  }

  return (
    <FilterSearchInput
      id="search-within-results"
      className="secondary-filters__search"
      value={value}
      onChange={handleChange}
      placeholder={translate('search_page.filters.secondary.search_placeholder')}
      ariaLabel={translate('search_page.filters.secondary.search_placeholder')}
    />
  )
}

export default memo(SearchWithinResults)
